import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetInvoicesArgs } from "../schemas";

const getInvoicesQueryKey = (args: GetInvoicesArgs) =>
  ["getInvoices", args.health_care_organization_id, args.params] as const;

export const useGetInvoices = (args: GetInvoicesArgs, options?: { enabled?: boolean }) => {
  const client = useApiClient();
  return useQuery(getInvoicesQueryKey(args), () => client.getInvoices(args), options);
};
